import FirestoreLifecycle from "../../types/FirestoreLifecycle";
import getCollectionData from "../../utils/getCollectionData";
import runBatch from "../../utils/runBatch";

import getArticlesQuery from "../articles/getArticlesQuery";

export default async function deleteWork(firebase, { work, user }) {
	const articles = await getCollectionData(getArticlesQuery(firebase, { work }));

	const softDelete = FirestoreLifecycle.partial().parse({
		deleted: true,
		deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
		deletedBy: user,
	});

	return runBatch(firebase, (transaction) => {
		for (const article of articles) {
			transaction.update(article.ref, softDelete);
		}

		transaction.update(work.ref, softDelete);
	});
}
